import Vue, { VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { CombinedVueInstance } from 'vue/types/vue';

function priceFormat() {
	return (el: HTMLElement, binding: DirectiveBinding, vNode: VNode) => {
		const input: HTMLInputElement = el.querySelector('input') as HTMLInputElement;

		el.addEventListener('input', () => {
			const context: CombinedVueInstance<Vue, unknown, unknown, unknown, any> = vNode.context;

			const char = input.value.indexOf('.') === -1 ? ',' : '.';
			const arr = input.value.split(char);

			if (arr[1])
				arr[1] = arr[1].slice(0, 2);

			input.value = arr.join(char);
			input.value = input.value.replace(/[^0-9,.]+/g, '');

			if (/\./.test(binding.expression))
				context[binding.expression.replace(/\..+/, '')][binding.expression.replace(/.+?\./, '')] = input.value;
			else
				context[binding.expression] = input.value;

		});
	};
}

Vue.directive('priceFormat', {
	bind: priceFormat()
});
